<template>
  <div class="custom-page-header">

    <!-- 内容区域 -->
    <button class="header-back-btn" type="button" @click="goBack">
      <span class="header-back-icon" aria-hidden="true">
        <el-icon>
          <ArrowLeft />
        </el-icon>
      </span>
      <span>返回</span>
    </button>

    <span class="header-divider" aria-hidden="true"></span>

    <div class="page-header-content">
      <div class="avatar-info">

        <div class="identity-card">

          <el-popover :width="360" trigger="hover" placement="bottom-start" popper-class="user-profile-popper">
            <template #reference>
              <button class="avatar-trigger" type="button">
                <el-avatar :src="userData.imageUrl" :size="56">
                  {{ userInitial }}
                </el-avatar>
              </button>
            </template>

            <template #default>
              <section class="profile-panel">
                <div class="profile-hero">
                  <div class="avatar-wrap">
                    <el-avatar :src="userData.imageUrl" :size="72">
                      {{ userInitial }}
                    </el-avatar>

                    <el-upload class="avatar-uploader" action="https://diagapi.wwftool.top/api/v1/user/myUploadFile"
                      :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleAvatarError"
                      :before-upload="beforeAvatarUpload" :headers="uploadHeaders">
                      <button class="avatar-upload-btn" type="button" title="上传头像">
                        <el-icon>
                          <Upload />
                        </el-icon>
                      </button>
                    </el-upload>
                  </div>

                  <div class="profile-summary">
                    <div class="profile-name-row">
                      <strong>{{ userData.username || '未设置名称' }}</strong>
                      <el-tag size="small" effect="dark" class="status-tag">
                        {{ userData.webstatus || 'USER' }}
                      </el-tag>
                    </div>
                    <div class="profile-subtitle">
                      {{ userData.job || '未设置岗位' }}
                    </div>
                  </div>
                </div>

                <div class="profile-actions">
                  <button class="profile-action" type="button" @click="dialogFormVisible2 = true">
                    <span class="action-icon">
                      <el-icon>
                        <EditPen />
                      </el-icon>
                    </span>
                    <span class="action-copy">
                      <strong>修改显示名称</strong>
                      <small>用于站点内展示和贡献者信息</small>
                    </span>
                  </button>

                  <button class="profile-action" type="button" @click="dialogFormVisible = true">
                    <span class="action-icon">
                      <el-icon>
                        <Lock />
                      </el-icon>
                    </span>
                    <span class="action-copy">
                      <strong>修改登录密码</strong>
                      <small>定期更新可以保护账号安全</small>
                    </span>
                  </button>
                </div>

                <div class="profile-footer">
                  <span>请勿泄露个人账号密码</span>
                  <el-button type="danger" plain size="small" :icon="SwitchButton" @click="handleLogout">
                    退出
                  </el-button>
                </div>

              </section>
            </template>
          </el-popover>

          <div class="avatar-text-container">
            <span class="header-kicker">{{ currentGreeting }} · {{ brandSlogan }}</span>
            <div class="identity-line">
              <strong class="username">{{ userData.username || '未设置名称' }}</strong>
              <el-tag size="small" effect="dark" class="inline-status">
                {{ userData.webstatus || 'USER' }}
              </el-tag>
            </div>
            <div class="identity-meta">
              <span>{{ userData.job || '未设置岗位' }}</span>
              <i></i>
              <span>{{ routeTitle }}</span>
            </div>
          </div>

        </div>

      </div>
    </div>

    <!-- 右侧功能 -->
    <div class="page-header-extra">

      <!-- PC -->
      <el-segmented v-if="!isMobile" class="header-segment" v-model="val1" :options="headerOptions" size="large"
        @change="handleSegmentChange" />

      <!-- Mobile -->
      <el-dropdown v-else trigger="click" @command="handleSegmentChange">
        <el-button class="mobile-menu-btn">
          webford
        </el-button>

        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="item in headerOptions"
              :key="item.value"
              :command="item.value"
              :disabled="item.disabled"
            >
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <Drawerlog v-model="showDrawer" />
      <ApiAnalysis v-model="showApiAnalysis" />
      <QuerySettings v-model="showQuerySettings" />

    </div>

  </div>

  <!-- 修改用户名 -->
  <el-dialog v-model="dialogFormVisible2" title="修改站点显示名称" width="460px" class="profile-dialog">
    <el-form label-position="top">
      <el-form-item label="当前:">
        <el-input v-model="userData.username" disabled />
      </el-form-item>
      <el-form-item label="修改:">
        <el-input v-model="NewName" placeholder="请输入新的显示名称" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="dialogFormVisible2 = false">取消</el-button>
      <el-button type="primary" @click="handleChangeName">提交</el-button>
    </template>
  </el-dialog>

  <!-- 修改密码 -->
  <el-dialog v-model="dialogFormVisible" title="修改密码" width="460px" class="profile-dialog">
    <el-form label-position="top">
      <el-form-item label="当前密码:">
        <el-input v-model="NewPW.oldPW" type="password" show-password placeholder="请输入当前密码" />
      </el-form-item>
      <el-form-item label="新密码:">
        <el-input v-model="NewPW.NewPW1" type="password" show-password placeholder="请输入新密码" />
      </el-form-item>
      <el-form-item label="确认密码:">
        <el-input v-model="NewPW.NewPW2" type="password" show-password placeholder="请再次输入新密码" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="handleChangePassword">提交</el-button>
    </template>
  </el-dialog>

</template>

<script>
import { ref, reactive, watch, onMounted, onBeforeUnmount, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import Drawerlog from './Drawerlog.vue'
import ApiAnalysis from './ApiAnalysis.vue'
import QuerySettings from './QuerySettings.vue'
import { ArrowLeft, EditPen, Lock, SwitchButton, Upload } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { userSaveName, userSavePassword } from '../api/users'
import { clearAuthCache } from '../router/index'
import { topEntryState } from '@/utils/adminAccess.mjs'

export default {

  components: {
    Drawerlog,
    ApiAnalysis,
    QuerySettings,
    ArrowLeft,
    EditPen,
    Lock,
    SwitchButton,
    Upload
  },

  setup() {

    /* 移动端识别 */
    const isMobile = ref(window.innerWidth <= 768)

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
    })

    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const userData = ref(JSON.parse(JSON.stringify(store.state.userData)))

    const userInitial = ref((userData.value.username || 'U').slice(0, 1).toUpperCase())

    const val1 = ref('webford')

    const options = [
      { label: 'webford', value: 'webford' },
      { label: '在线接口类型解析', value: '1' },
      { label: '接口文档', value: '2' },
      { label: '更新内容', value: '3' },
      { label: '查询设置', value: '4' }
    ]

    const headerOptions = computed(() => options.map((item) => ({
      ...item,
      disabled: topEntryState(store.state.userData, item.value) === 'disabled'
    })))

    const headerSlogansMoreMap = {
      morning: [
        '早安开工，今天也要一路顺风',
        '元气上线，好运正在派送',
        '新的一天，继续向前冲',
        '今日状态满格，工作顺利开局',
        '愿你今天思路清晰，事事顺心',
        '带上好心情，开启今日任务',
        '早起有光，努力有回响',
        '今天也要认真工作，快乐生活'
      ],

      noon: [
        '午间充电完成，下午继续发光',
        '吃饱喝足，元气重新满格',
        '短暂休息，为下午积蓄能量',
        '好好吃饭，好好生活，好好努力',
        '午休一下，醒来继续顺风顺水',
        '补充能量，下午继续拿下目标',
        '饭已吃好，好运继续报道',
        '中午稳住节奏，下午继续向前'
      ],

      afternoon: [
        '下午状态在线，继续稳步推进',
        '保持专注，好结果正在靠近',
        '每完成一项，都是今日的进步',
        '继续努力，今天一定有所收获',
        '稳住心态，问题总有解决办法',
        '下午继续冲，目标就在前方',
        '认真做好当下，好事自然发生',
        '保持节奏，今天一定顺利收尾'
      ],

      evening: [
        '今日任务完成，开心准备收工',
        '辛苦一天，记得为自己点赞',
        '带着收获下班，带着期待回家',
        '今天表现不错，明天继续加油',
        '认真收尾，轻松下班',
        '结束忙碌，开启生活模式',
        '今日努力已到账，可以安心休息',
        '下班快乐，明天继续闪闪发光'
      ],

      night: [
        '夜深了，记得给自己留点休息时间',
        '今天已经很努力，早点休息吧',
        '保存进度，明天继续向前',
        '放下工作，给大脑充充电',
        '愿今晚好梦，明天好运',
        '忙碌一天，也要照顾好自己',
        '休息不是停下，是为了走得更远',
        '结束今天，期待明天新的收获'
      ]
    };



    const homeSlogansMoreMap = {
      night: [
        '今天多走一步，明天更进一步',
        '夜虽已深，目标依然清晰',
        '坚持到最后，就是最好的答卷',
        '每一次努力，都在为未来铺路',
        '再认真一点，离成功就近一点',
        '今天的付出，都会成为明天的底气',
        '稳住节奏，完成今天的目标',
        '努力不会白费，成长正在发生',
        '认真收尾，漂亮结束今天',
        '保持热爱，继续向前'
      ],

      morning: [
        '早安，元气满满开工',
        '新的一天，新的进步',
        '保持状态，向目标出发',
        '今天也要努力发光',
        '打起精神，开启精彩一天',
        '认真工作，好运自然来',
        '带着目标，坚定前行',
        '今天比昨天更进一步',
        '元气上线，努力开工',
        '心有方向，脚下有力量'
      ],

      noon: [
        '补充能量，下午继续冲',
        '好好吃饭，认真生活',
        '休息一下，为下午蓄力',
        '吃饱喝足，元气恢复',
        '短暂休息，是为了更好出发',
        '调整状态，继续前进',
        '补满能量，再战下午',
        '认真吃饭，也是认真工作',
        '午间充电，动力满格',
        '保持节奏，稳步向前'
      ],

      afternoon: [
        '保持专注，继续突破',
        '再坚持一下，目标就在前方',
        '稳扎稳打，完成今天的任务',
        '每解决一个问题，都是一次成长',
        '状态在线，继续努力',
        '专注当下，结果不会差',
        '困难正在减少，进步正在增加',
        '不急不躁，一步一步来',
        '继续加油，今天一定有收获',
        '认真到底，惊喜自然出现'
      ],

      evening: [
        '认真收尾，为今天点赞',
        '今天很努力，明天更优秀',
        '完成目标，安心收工',
        '辛苦一天，收获满满',
        '今天的努力值得肯定',
        '带着成果，开心下班',
        '稳稳完成，漂亮收官',
        '工作有收获，生活有期待',
        '结束忙碌，迎接美好',
        '明天继续，未来可期'
      ]
    };

    const getTimePeriod = () => {
      const hour = new Date().getHours()
      if (hour < 6) return 'night'
      if (hour < 12) return 'morning'
      if (hour < 14) return 'noon'
      if (hour < 18) return 'afternoon'
      if (hour < 22) return 'evening'
      return 'night'
    }

    const randomPick = (list) => list[Math.floor(Math.random() * list.length)]
    const sloganCacheKey = 'webford-page-header-slogans'

    const getStableSlogans = () => {
      const period = getTimePeriod()

      try {
        const cached = JSON.parse(localStorage.getItem(sloganCacheKey) || 'null')
        if (
          cached &&
          cached.period === period &&
          cached.brandSlogan &&
          cached.homeSlogan
        ) {
          return cached
        }
      }
      catch {
        localStorage.removeItem(sloganCacheKey)
      }

      const next = {
        period,
        brandSlogan: randomPick(headerSlogansMoreMap[period]),
        homeSlogan: randomPick(homeSlogansMoreMap[period])
      }

      localStorage.setItem(sloganCacheKey, JSON.stringify(next))
      return next
    }

    const stableSlogans = getStableSlogans()
    const brandSlogan = ref(stableSlogans.brandSlogan)
    const homeSlogan = ref(stableSlogans.homeSlogan)

    const currentGreeting = computed(() => {
      const hour = new Date().getHours()

      if (hour < 6) return '夜间维护'
      if (hour < 12) return '上午好'
      if (hour < 14) return '中午好'
      if (hour < 18) return '下午好'
      if (hour < 22) return '晚上好'
      return '夜深了'
    })

    const routeTitle = computed(() => homeSlogan.value)

    const updateSegment = () => {
      const path = route.path

      if (path.startsWith('/apidoc')) {
        val1.value = '2'
      }
      else if (path === '/') {
        val1.value = 'webford'
      }
    }

    onMounted(() => {
      updateSegment()
    })

    watch(() => route.path, () => {
      updateSegment()
    })

    const showDrawer = ref(false)
    const showApiAnalysis = ref(false)
    const showQuerySettings = ref(false)

    const dialogFormVisible = ref(false)
    const dialogFormVisible2 = ref(false)

    const NewName = ref('')

    const NewPW = reactive({
      oldPW: '',
      NewPW1: '',
      NewPW2: ''
    })

    const uploadHeaders = ref({
      Authorization: 'Bearer ' + localStorage.getItem("authToken")
    })

    const handleSegmentChange = (value) => {

      if (topEntryState(store.state.userData, value) === 'disabled') {
        val1.value = 'webford'
        ElMessage.warning('当前账号无此入口权限')
        return
      }

      val1.value = value

      if (value === '2') {
        router.push('/apidoc')
      }
      else if (value === '3') {
        showDrawer.value = true
      }
      else if (value === '1') {
        showApiAnalysis.value = true
      }
      else if (value === '4') {
        showQuerySettings.value = true
      }
      else {
        router.push('/')
      }

    }

    const handleChangeName = async () => {

      dialogFormVisible2.value = false

      try {

        const res = await userSaveName({
          username: NewName.value
        })

        store.commit('setUserData', res.data.userInfo)

        userData.value = res.data.userInfo
        userInitial.value = (userData.value.username || 'U').slice(0, 1).toUpperCase()

        ElMessage.success('设置成功')

      }
      catch {

        ElMessage.error('设置失败')

      }

    }

    const handleChangePassword = async () => {

      dialogFormVisible.value = false

      if (!NewPW.oldPW || !NewPW.NewPW1 || !NewPW.NewPW2) {
        ElMessage.error('请填写完整')
        return
      }

      if (NewPW.NewPW1 !== NewPW.NewPW2) {
        ElMessage.error('新密码不一致')
        return
      }

      try {

        await userSavePassword(NewPW)

        ElMessage.success('设置成功')

      }
      catch {

        ElMessage.error('设置失败')

      }

      NewPW.oldPW = ''
      NewPW.NewPW1 = ''
      NewPW.NewPW2 = ''

    }

    const handleLogout = () => {

      ElMessageBox.confirm('确定退出当前账号吗？', '退出登录')
        .then(() => {

          localStorage.clear()

          clearAuthCache()

          router.replace({ name: 'LoginView' })

          ElMessage.success('已退出登录')

        })

    }

    const handleAvatarSuccess = (res) => {

      userData.value.imageUrl = res.imageUrl
      store.commit('setUserData', {
        ...store.state.userData,
        imageUrl: res.imageUrl
      })

      ElMessage.success('头像上传成功')

    }

    const handleAvatarError = () => {

      ElMessage.error('头像上传失败')

    }

    const beforeAvatarUpload = (file) => {

      const isValid = ['image/jpeg', 'image/png'].includes(file.type)

      if (!isValid) {
        ElMessage.error('仅支持 JPG/PNG')
        return false
      }

      if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('不能超过2MB')
        return false
      }

      return true

    }

    const goBack = () => {

      if (window.history.length > 1) {
        router.back()
      } else {
        router.push('/login')
      }

    }

    return {

      isMobile,
      userData,
      userInitial,
      currentGreeting,
      brandSlogan,
      routeTitle,
      val1,
      options,
      headerOptions,
      showDrawer,
      showApiAnalysis,
      showQuerySettings,
      dialogFormVisible,
      dialogFormVisible2,
      NewName,
      NewPW,
      uploadHeaders,
      handleSegmentChange,
      handleChangeName,
      handleChangePassword,
      handleLogout,
      handleAvatarSuccess,
      handleAvatarError,
      beforeAvatarUpload,
      goBack,
      SwitchButton

    }

  }

}
</script>

<style scoped>
.custom-page-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.header-back-btn {
  height: 42px;
  min-width: 78px;
  padding: 0 14px 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  border: 1px solid rgba(203, 213, 225, 0.9);
  border-radius: 999px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  color: #0f172a;
  cursor: pointer;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.header-back-btn:hover {
  transform: translateY(-1px);
  border-color: rgba(34, 211, 238, 0.8);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
}

.header-back-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ecfeff;
  color: #0891b2;
}

.header-divider {
  width: 1px;
  height: 28px;
  background: rgba(203, 213, 225, 0.8);
  flex: 0 0 auto;
}

.page-header-content {
  min-width: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.page-header-extra {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  margin-left: auto;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.avatar-info {
  display: flex;
  align-items: center;
}

.identity-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 290px;
  padding: 6px 16px 6px 0;
  border-radius: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.identity-card::before {
  display: none;
}

.avatar-trigger {
  position: relative;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #0f172a, #1e293b);
  cursor: pointer;
  line-height: 0;
  box-shadow: 0 0 0 3px rgba(34, 211, 238, 0.22), 0 12px 28px rgba(15, 23, 42, 0.18);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.avatar-trigger:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 0 4px rgba(34, 211, 238, 0.34), 0 16px 34px rgba(15, 23, 42, 0.22);
}

.avatar-trigger :deep(.el-avatar) {
  border: 2px solid #ffffff;
  font-weight: 800;
}

.avatar-text-container {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  gap: 5px;
  min-width: 0;
  padding-left: 8px;
}

.header-kicker {
  color: #0f766e;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0;
}

.identity-line {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.username {
  color: #0f172a;
  font-size: 18px;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inline-status {
  flex: 0 0 auto;
  border: 0;
  background: #0f172a;
  color: #ffffff;
  font-weight: 700;
}

.identity-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.identity-meta span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.identity-meta i {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #22c55e;
  flex: 0 0 auto;
}

.mobile-menu-btn {
  height: 40px;
  border: 0 !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #facc15 0%, #f59e0b 100%) !important;
  color: #1f2937 !important;
  font-weight: 700;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.48), 0 10px 22px rgba(180, 83, 9, 0.18);
}

:deep(.header-segment) {
  --el-segmented-bg-color: #f3f6fa;
  --el-segmented-item-selected-bg-color: #facc15;
  --el-segmented-item-selected-text-color: #111827;
  --el-border-radius-base: 14px;
  padding: 5px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.92), 0 10px 24px rgba(15, 23, 42, 0.06);
}

:deep(.header-segment .el-segmented__item) {
  min-height: 36px;
  padding: 0 12px;
  font-weight: 700;
  color: #334155;
  border-radius: 11px;
  transition: color 0.18s ease, background-color 0.18s ease, transform 0.18s ease;
}

:deep(.header-segment .el-segmented__item:hover) {
  color: #111827;
  background: rgba(255, 251, 235, 0.86);
  transform: translateY(-1px);
}

:deep(.header-segment .el-segmented__item.is-selected) {
  background: linear-gradient(135deg, #fde047 0%, #facc15 48%, #f59e0b 100%);
  color: #111827;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 8px 18px rgba(180, 83, 9, 0.18);
}

:deep(.header-segment .el-segmented__item-selected) {
  background: linear-gradient(135deg, #fde047 0%, #facc15 48%, #f59e0b 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 8px 18px rgba(180, 83, 9, 0.18);
}

:global(.user-profile-popper.el-popper) {
  padding: 0 !important;
  border: 1px solid rgba(226, 232, 240, 0.95) !important;
  border-radius: 14px !important;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

.profile-panel {
  background: #ffffff;
}

.profile-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #fff7cc 0%, #ffffff 58%, #eef6ff 100%);
  border-bottom: 1px solid #edf2f7;
}

.avatar-wrap {
  position: relative;
  flex: 0 0 auto;
}

.avatar-wrap :deep(.el-avatar) {
  border: 3px solid #ffffff;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.16);
  font-size: 24px;
  font-weight: 700;
}

.avatar-uploader {
  position: absolute;
  right: -2px;
  bottom: -2px;
  line-height: 0;
}

.avatar-upload-btn {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: #111827;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.2);
  transition: transform 0.18s ease, background-color 0.18s ease;
}

.avatar-upload-btn:hover {
  transform: translateY(-1px);
  background: #000000;
}

.profile-summary {
  min-width: 0;
  flex: 1;
}

.profile-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.profile-name-row strong {
  color: #111827;
  font-size: 18px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-tag {
  border: 0;
  background: #111827;
  color: #ffffff;
  flex: 0 0 auto;
}

.profile-subtitle {
  margin-top: 6px;
  color: #64748b;
  font-size: 13px;
}

.profile-actions {
  padding: 10px;
}

.profile-action {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.profile-action:hover {
  background: #f8fafc;
  transform: translateY(-1px);
}

.action-icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
  color: #0f172a;
  flex: 0 0 auto;
}

.action-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.action-copy strong {
  color: #111827;
  font-size: 14px;
  line-height: 1.25;
}

.action-copy small {
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
}

.profile-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border-top: 1px solid #edf2f7;
  color: #64748b;
  font-size: 12px;
}

.profile-dialog :deep(.el-dialog) {
  border-radius: 14px;
  overflow: hidden;
}

.profile-dialog :deep(.el-dialog__header) {
  margin: 0;
  padding: 18px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.profile-dialog :deep(.el-dialog__body) {
  padding: 20px;
}

.profile-dialog :deep(.el-dialog__footer) {
  padding: 0 20px 20px;
}

.profile-dialog :deep(.el-input__wrapper) {
  border-radius: 10px;
}

@media (max-width: 768px) {

  .custom-page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .header-divider {
    display: none;
  }

  .page-header-extra {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }

  .profile-footer {
    align-items: flex-start;
    flex-direction: column;
  }

}
</style>
